import { AdminPipelineStatusService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { adminJobsKeys } from 'app/queries/adminJobs/adminJobsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof adminJobsKeys.attemptLogsByAttempt>>;

export const createFetchAttemptLogsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ attemptId }], signal }: TParams) =>
    call(() => cancelOnSignal(AdminPipelineStatusService.getAttemptLogs({ attemptId }), signal));
